@if (isBrowser) {
  <app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>
  <!-- <app-incomplete-info-warning></app-incomplete-info-warning> -->

  <section class="cart-section section-b-space pt-0">
    <div class="container-fluid-lg">
      <div class="row">
        <div class="col-xxl-8 col-xl-8 d-flex flex-column" style="gap: 12px">
          <div
            class="left-col sticky"
            style="padding-top: 12px; background-color: #f9f9f9"
          >
            <div class="input-group align-items-center border div-search">
              <input
                #inputSearch
                id="quiclSearchInput"
                type="search"
                class="form-control border-0 bg-transparent search-input"
                placeholder="Nhập tên thuốc, hoạt chất cần tìm..."
                [(ngModel)]="inputText"
                (keyup)="input()"
                (search)="input()"
              />
              <button class="border-0 bg-transparent" (click)="input()">
                <i
                  class="ri-search-line d-flex justify-content-center align-items-center search-icon"
                ></i>
              </button>
            </div>
          </div>

          <div class="container-box">
            <div class="d-flex align-items-center py-1 gap-4 overflow-auto">
              <button
                *ngFor="let btn of filters"
                class="div-tag pe-4 ps-4 pt-2 pb-2 bg-green"
                [class.active]="btn.active"
                [class.pulse]="btn.value == '1'"
                [class.pulse-2]="btn.value == '2'"
                [class.pulse-3]="btn.value == '3'"
                [class.pulse-4]="btn.value == '4'"
                [class.pulse-5]="btn.value == '5'"
                [id]="btn.value == '1' ? 'GTT-PV' : ''"
                (click)="filter(btn)"
                style="min-width: fit-content"
              >
                <img
                  *ngIf="btn.icon"
                  [src]="btn.icon"
                  style="width: 20px; height: 20px"
                  alt="icon"
                 loading="lazy" />
                <h6>{{ btn.name }}</h6>
              </button>
            </div>

            <div style="height: 1px; background-color: #dee2e6"></div>

            <div class="cart-table p-0">
              @if (items.length > 0 || itemsExtend.length > 0 || suggestion || skeletonLoader || suggestionPending) {
                <div class="quick-table-list table align-middle">
                  <div
                    *ngIf="!isVipCustomer"
                    class="quick-price-note"
                  >
                    *Giá bạn đang xem là giá đã giảm sau khi áp dụng các chương trình bán hàng như chiết khấu trên đơn, chiết khấu sản phẩm, mã ưu đãi cho khách hàng và các ưu đãi khác...
                  </div>

                  <!-- Gợi ý tìm kiếm: chỉ có thì mới hiện, nằm trên kết quả thường và đẩy kết quả thường xuống -->
                  @if (suggestion; as s) {
                    @if (s.map; as map) {
                      <div class="d-flex align-items-baseline justify-content-between gap-3">
                        <span class="fw-bold" style="padding: 0; font-size: 16px;">
                          Có phải bạn muốn tìm: <strong>{{ map.rewriteTo }}</strong>?
                        </span>
                        @if (map.total > map.products.length) {
                          <a
                            class="fw-semibold text-nowrap"
                            role="button"
                            (click)="searchRewrite(map.rewriteTo)"
                            >Xem tất cả ({{ map.total }})</a
                          >
                        }
                      </div>
                      <ng-container
                        [ngTemplateOutlet]="tableContent"
                        [ngTemplateOutletContext]="{ items: map.products }"
                      ></ng-container>
                    }
                    @if (s.equivalent; as equivalent) {
                      <div>
                        <span class="fw-bold" style="padding: 0; font-size: 16px;">GiaThuocTot gợi ý</span>
                      </div>
                      <ng-container
                        [ngTemplateOutlet]="tableContent"
                        [ngTemplateOutletContext]="{ items: equivalent.products }"
                      ></ng-container>
                    }
                    @if (showNormalResults) {
                      <div>
                        <span class="fw-bold" style="padding: 0; font-size: 16px;">Kết quả cho “{{ s.term }}”</span>
                      </div>
                    }
                  }

                  @if (showNormalResults) {
                    <ng-container
                      [ngTemplateOutlet]="tableContent"
                      [ngTemplateOutletContext]="{ items: items }"
                    ></ng-container>

                    <!-- Có gợi ý nhưng tìm thường không ra gì: nói rõ để không bị nhầm gợi ý (hay danh sách "Có thể bạn muốn tìm" bên dưới) là kết quả của từ khóa -->
                    @if (suggestion && !items.length && !skeletonLoader) {
                      <div class="text-muted" style="padding: 0 0 8px">
                        Không tìm thấy sản phẩm nào cho “{{ suggestion.term }}”.
                      </div>
                    }

                    <ng-container
                      *ngIf="
                        showSkeleton;
                        else productContent
                      "
                    >
                      <div
                        *ngFor="let item of skeletonItems"
                        class="quick-skeleton-item"
                      >
                        <app-skeleton-product-box></app-skeleton-product-box>
                      </div>
                    </ng-container>
                  }

                  <ng-template #productContent>
                    <div
                      *ngIf="itemsExtend.length && itemsExtend.length > 0"
                    >
                      <span class="fw-bold" style="padding: 0; font-size: 16px;">Có thể bạn muốn tìm</span>
                    </div>
                    <ng-container
                      [ngTemplateOutlet]="tableContent"
                      [ngTemplateOutletContext]="{ items: itemsExtend }"
                    ></ng-container>
                  </ng-template>
                </div>
              }
            </div>

            <ng-template #tableContent let-items="items">
              <div
                *ngFor="let item of items; let i = index"
                class="d-flex flex-column quick-item"
              >
                <div class="quick-item-product d-flex align-items-center p-0" style="gap: 30px">
                  <app-product-box-vertical
                    [product]="item"
                    class="w-100"
                    [close]="true"
                    [showAlternativesBtn]="false"
                  >
                  </app-product-box-vertical>
                </div>
                <div
                  *ngIf="
                    item.basePrice <= 0 &&
                    item.stockStatus != 8 &&
                    item.productAlternatives != null &&
                    item.productAlternatives.length > 0
                  "
                  class="quick-item-product d-flex align-items-center p-0 w-100 justify-content-end"
                >
                  <app-product-box-alternative class="alter-product"
                    [id]="item?.productAlternatives[0]?.productId"
                    [quantity]="
                      quantityAlternativeMap[
                        item?.productAlternatives[0]?.productId
                      ] || 0
                    "
                    [parentProduct]="item"
                  ></app-product-box-alternative>
                </div>
              </div>
            </ng-template>

            <app-collection-paginate></app-collection-paginate>
            <app-no-data
              [class]="'no-data-added collection-no-data'"
              [image]="'assets/svg/no-product.svg'"
              [text]="'Không tìm thấy sản phẩm nào!'"
              [description]="'Bạn hãy thử tìm lại với từ khóa khác nhé!'"
              *ngIf="
                items.length == 0 && itemsExtend.length == 0 && !skeletonLoader && !suggestionPending && !suggestion
              "
            >
            </app-no-data>
          </div>
        </div>
        <div class="col-xxl-4 col-xl-4 total" style="padding-top: 12px">
          <div class="container-box sticky">
            <app-header-cart
              [sidebarCartOpen]="true"
              [progressData]="progressData"
              [additionalCoins]="additionalCoins"
              [additionalRankingCoins]="additionalRankingCoins"
              [isExceededMinimumMilestone]="isExceededMinimumMilestone"
            >
            </app-header-cart>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-product-detail-image-modal
    #productDetailImageModal
    [title]="title"
    [images]="imageUrls"
  >
  </app-product-detail-image-modal>
  <app-voucher-modal
    #voucherModal
    *ngIf="!skeletonLoader"
    [cart]="cart"
    [isInCartPage]="false"
    [selectedCode]="selectedVoucherCode"
  >
  </app-voucher-modal>
}
